// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uk-container[data-v-b67a489e]{min-height:90px}.uk-container .spinner[data-v-b67a489e]{margin:auto;width:90px;display:block}\n", ""]);
// Exports
module.exports = exports;
